<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>场馆监管系统</el-breadcrumb-item>
        <el-breadcrumb-item>游泳馆</el-breadcrumb-item>
        <el-breadcrumb-item>游泳馆管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange"
    >
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px;">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column prop="stadiumImg" align="center" label="场馆图片">
          <template slot-scope="scope">
            <div class="wrap-picture-style">
              <img :src="scope.row.stadiumImg" alt="" />
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="stadiumName" align="center" label="场馆名称">
        </el-table-column>

        <el-table-column prop="stadiumAddress" align="center" label="场馆地址">
        </el-table-column>

        <el-table-column prop="" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="linkToDetailPage(scope.row.id)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        stadiumType: ""
      },
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0
      }
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    /**
     * 加载列表数据
     */
    loadTableData() {
      const bodyParams = Object.assign({}, this.listParams, {
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize
      });
      bodyParams.stadiumType = parseInt(this.$route.params.stadiumType);
      this.$http({
        url: global.apiUrl + "/stadiumManage/list",
        method: "GET",
        params: bodyParams
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data && res.body.data.dataList.length > 0) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {

            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 跳转至详情页
     * @param id
     */
    linkToDetailPage(id) {
      this.$router.push({
        name: "swimmingDetail",
        query: {
          id: id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
  .wrap-picture-style {
    width: 100px;
    height: 60px;
    position: relative;
    overflow: hidden;
    margin: auto;
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
</style>
